import {
  Box,
  Chip,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Logo from "../../../images/LOGO.svg";
import logoTitle from "../../../images/LOGO_Title.svg";
import { useSearchParams } from "react-router-dom";

const Reset = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetPass, setResetPass] = useState(true);
  const [savePass, setSavePass] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const resetCode = searchParams.get("resetCode");
    const username = searchParams.get("username");
    if (resetCode && username) {
      validateToken(resetCode, username);
    }
  }, [searchParams]);

  const validateToken = async (resetCode, username) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://rawdat.ai/reset-password/validation?username=${username}&resetCode=${resetCode}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        let text = await response.text();

        if (text === "The link is now validated") {
          setResetPass(false);
          setSavePass(true);
        } else {
          setError("Invalid Link");
        }
      } else {
        setError("Invalid or expired reset link.");
      }
    } catch (error) {
      setError("An error occurred while validating the reset link.");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("https://rawdat.ai/reset-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ email }),
      });

      const message = await response.text();
      setResponseMessage(message);
      setResetPass(false);
      setError("");
    } catch (error) {
      setError("An error occurred while sending the reset email.");
    } finally {
      setLoading(false);
    }
  };

  const handleSavePassword = async () => {
    const resetCode = searchParams.get("resetCode");
    const username = searchParams.get("username");

    if (!password || !confirmPassword) {
      setError("Please fill in both password fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await fetch("https://rawdat.ai/reset-password/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ password, username, resetCode }),
      });

      if (response.ok) {
        setSavePass(false);
        setError("");
        alert("Password reset successfully.");
      } else {
        setError("Failed to reset password. Please try again.");
      }
    } catch (error) {
      setError("An error occurred while resetting the password.");
    }
  };

  return (
    <Box
      sx={{
        height: "calc(100lvh - 80px)",
        overflow: "hidden",
        background: "linear-gradient(180deg, #000 38%, #1D6BAE 100%);",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          margin: "0 auto",
          display: "flex",
          gap: "8rem",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "35%",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            marginTop: "-7rem",
          }}
        >
          <img src={Logo} alt={"RAWDAT"} width={250} />
          <img src={logoTitle} alt={"RAWDATAI"} width={250} />
        </Box>

        <Box
          sx={{
            width: "567px",
            padding: "48px",
            display: "flex",
            flexDirection: "column",
            gap: "36px",
            backgroundColor: "#fff",
            border: `1px solid #888`,
            borderRadius: "8px",
            marginTop: "-7rem",
          }}
        >
          <Typography variant="h4">Reset Password</Typography>
          {error && <Typography color="error">{error}</Typography>}
          {responseMessage && (
            <Typography variant="body2">{responseMessage}</Typography>
          )}
          {loading ? (
            <CircularProgress />
          ) : resetPass ? (
            <>
              <TextField
                variant="outlined"
                label={"Your Email address"}
                name={"email"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Chip
                variant={"filled"}
                color="primary"
                label={"Reset your password"}
                sx={{ width: "100%", cursor: "pointer", height: "40px" }}
                onClick={handleResetPassword}
              />
            </>
          ) : savePass ? (
            <>
              <TextField
                variant="outlined"
                label={"New Password"}
                name={"password"}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <TextField
                variant="outlined"
                label={"Confirm password"}
                name={"cpassword"}
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <Chip
                variant={"filled"}
                color="primary"
                label={"Save password"}
                sx={{ width: "100%", cursor: "pointer", height: "40px" }}
                onClick={handleSavePassword}
              />
            </>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default Reset;
